<template>
<div class="perusahaan">
               
  <vue-perfect-scrollbar class="chat-history--scrollbar">
    <v-divider></v-divider>
    <v-list two-line class="chat-contact--list">

      <!-- Table Start -->

      <v-flex lg12 md12>
        <v-toolbar card color="white">
          <v-text-field
          flat
          solo
          prepend-icon="search"
          placeholder="Type something"
          v-model="search"
          hide-details
          class="hidden-sm-and-down"
          ></v-text-field>

          <v-btn v-if="role === 'gapoktan.agroforestcape@gmail.com'" color="primary" form="tambahkan-gapoktan" @click="tambahkanGapoktan"><v-icon>add</v-icon><h5>Tambahkan Gapoktan</h5></v-btn>
          <v-btn v-else color="primary" form="tambahkan-Lahan" @click="tambahkanLahan"><v-icon>add</v-icon><h5>Tambahkan Lahan</h5></v-btn>
     
        </v-toolbar>
  
        <v-divider></v-divider>
  
        <v-data-table
          :headers="complex.headers"
          :search="search"
          :items="complex.items"
          :rows-per-page-items="[15,25,50,{text:'All','value':-1}]"
          class="elevation-1 data-fonts"
          item-key="name"
          v-model="complex.selected"
          >
          <template slot="items" slot-scope="props">
            <td class="data-fonts">{{ props.item.nama }}</td>
            <td class="data-fonts">{{ props.item.kode }}</td>
            <td class="data-fonts">{{ props.item.narahubung }}</td>
            <td class="data-fonts">{{ props.item.phone }}</td>
            <td class="data-fonts">{{ props.item.alamat.street }}</td>
            <td class="data-fonts" v-if="props.item.website">{{ props.item.website }}</td>
            <td class="data-fonts" v-else>-</td>
            <td class="data-fonts">{{ props.item.unitUsaha }}</td>
            <td class="data-fonts">{{ props.item.status }}</td>
            <td class="data-fonts">
              <v-btn depressed outline icon fab dark color="primary" small :to="editGapoktan(props.item.uuid)">
                <v-icon>fas fa-file-alt</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-flex>  

      <!-- Table End -->
      
    </v-list>  
  </vue-perfect-scrollbar>  
</div>
</template>

<script>
import { getGapoktan } from '@/api/gapoktan';
import { Items as Users } from '@/api/gapoktan';

import VCircle from '@/components/circle/VCircle';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import VWidget from '@/components/VWidget';

export default {
  components: {
    VuePerfectScrollbar,
    VCircle,
    VWidget
  },

  data: () => ({ 
  }),

  data () {
    return {
      search: '',
      complex: {
        selected: [],
        headers: [
          {
            text: 'Nama Usaha',
            value: 'nama'
          },
          {
            text: 'Kode Penjualan',
            value: 'kode'
          },
          {
            text: 'Narahubung',
            value: 'narahubung'
          },
          {
            text: 'No Hp',
            value: 'phone'
          },
          {
            text: 'Alamat',
            value: 'alamat'
          },
          {
            text: 'Website',
            value: 'website'
          },
          {
            text: 'Unit Usaha Utama',
            value: 'unitUsaha'
          },
          {
            text: 'Terdaftar',
            value: 'status'
          },
          {
            text: 'Tindakan',
            value: ''
          },
        ],
        items: Users,
      },
      role: localStorage.userEmail,
    };
  },

  computed: {
    users () {
      return getUser();
    }
  },

  methods: {

    initialize(){
      this.items = Users;
      console.log("Cek Items : ", this.items);
    },

    deleteItem (item) {
      // const index = this.items.indexOf(item);
      console.log("Item Succesfully Deleted");
    },

    tambahkanGapoktan(){
      window.getApp.$emit('APP_TAMBAHKAN_GAPOKTAN');
    },

    tambahkanLahan(){
      window.getApp.$emit('APP_TAMBAHKAN_GAPOKTAN_LAHAN');
    },

    editGapoktan (id) {
      // return '/edit-perusahaan/' + id;
    },

    firstLetter (name) {
      return name.charAt(0);
    },

    userStatusColor (item) {
      return (item.active) ? 'green' : 'grey';
    }    
  }  
};
</script>

<style scoped>
  .data-fonts{
    font-size: 1em;
  }
</style>
